// extracted by mini-css-extract-plugin
export default {"container":"container___lTF_m","innerContainerSpacing":"innerContainerSpacing___eXhcH","bodyText":"bodyText___PnLcZ","itemsContainer":"itemsContainer___JsOMX"};